/**
 * Barramento leve para sincronizar os dados do paciente no dashboard.
 *
 * O interceptor de resposta do http (services/http.js) chama
 * `emitPatientDataChanged()` sempre que uma mutação (POST/PUT/PATCH/DELETE)
 * termina com sucesso. Os cards do dashboard (via mixin patientDataRefresh)
 * escutam e refazem seu `fetchData` — assim, inserir/editar/excluir em QUALQUER
 * card ou aba do drawer atualiza todos os cards, sem cada um precisar avisar.
 *
 * O emit tem um debounce curto para coalescer rajadas de mutações numa única
 * onda de refresh.
 */

const listeners = new Set();
let timer = null;

/** Registra um callback; retorna uma função para cancelar a inscrição. */
export function onPatientDataChanged(callback) {
  listeners.add(callback);
  return () => listeners.delete(callback);
}

/** Sinaliza que dados do paciente mudaram (debounced ~200ms). */
export function emitPatientDataChanged() {
  if (timer) clearTimeout(timer);
  timer = setTimeout(() => {
    timer = null;
    listeners.forEach((cb) => {
      try {
        cb();
      } catch (e) {
        // isola a falha de um listener para não travar os demais
        console.error("[patientDataBus] listener falhou:", e);
      }
    });
  }, 200);
}
